import tableRelatedLanguagesSingle from './tableRelatedLanguagesSingle';

export default {
  title: 'Languages',
  attributeName: 'locale',
  getURL: 'languages/localesPaginated',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'locale',
  itemId: 'locale',
  tableConfig: tableRelatedLanguagesSingle,
};